<template>
  <div>
    <strong class="fs_16" v-text="title" />
    <b-table
      class="bg-white mt-3 score_competency_table"
      :fields="fields"
      :items="wrapperItems"
    >
    </b-table>
  </div>
</template>

<script>
import { pathOr } from "ramda";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields: [
        {
          key: "caption",
          label: "عنوان",
          class: "w-50",
          thClass: "bg-info text-center p-1",
          tdClass: "bg-info text-left p-1 fs_12",
          isRowHeader: true,
        },
        {
          key: "score0",
          label: "ضعیف",
          thClass: "bg-info text-center p-1",
          tdClass: "p-0",
        },
        {
          key: "score1",
          label: "متوسط",
          thClass: "bg-info text-center p-1",
          tdClass: "p-0",
        },
        {
          key: "score2",
          label: "خوب",
          thClass: "bg-info text-center p-1",
          tdClass: "p-0",
        },
      ],
    };
  },
  computed: {
    wrapperItems() {
      return this.items.map((row) => {
        return {
          caption: pathOr(null, ["caption"], row),
          score0: "",
          score1: "",
          score2: "",
          _cellVariants: { ...this.renderCellVariants(row) },
        };
      });
    },
  },
  methods: {
    pathOr,
    renderCellVariants(row) {
      const data = {
        خوب: "success",
        متوسط: "warning",
        ضعیف: "danger",
        null: "",
      };

      return {
        score0:
          data[
            pathOr(null, ["score0"], row) ||
              pathOr(null, ["score1"], row) ||
              pathOr(null, ["score2"], row)
          ] || "",
        score1:
          data[
            pathOr(null, ["score1"], row) || pathOr(null, ["score2"], row)
          ] || "",
        score2: data[pathOr(null, ["score2"], row)] || "",
      };
    },
  },
};
</script>

<style lang="scss">
.score_competency_table {
  tr {
    background-color: #fff !important;
  }
  td {
    &.table-success {
      background-color: #4dbd74 !important;
    }
  }
}
</style>